var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 122,
    viewBox: "0 0 204 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4665 119.09H64.5629V71.588L37.4665 56.1999V119.09Z",
    fill: "#007ACC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.029 24.0856V2.00713H74.862L83.2961 24.0856H102.029Z",
    fill: "#007ACC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.0856H37.4665L59.2631 2.00713H0V24.0856Z",
    fill: "#007ACC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5629 24.0856H83.2961L74.862 2.00713L64.5629 24.0856Z",
    fill: "#007ACC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.526 116.247C174.055 119.48 164.967 121.097 154.262 121.097L154.429 99.3532C162.123 99.3532 167.81 98.2381 171.49 96.008C175.17 93.6663 177.01 90.5999 177.01 86.8086C177.01 84.0209 175.894 81.735 173.664 79.9509C171.546 78.0553 168.758 76.5499 165.301 75.4349C161.956 74.3198 157.384 73.0932 151.586 71.7551C142.665 69.6365 135.361 67.5178 129.675 65.3992C123.988 63.2805 119.081 59.8795 114.956 55.1962C110.941 50.5129 108.934 44.2685 108.934 36.463L135.863 35.1249C135.863 39.1391 137.926 42.1498 142.052 44.157C146.289 46.0526 152.701 47.9482 161.287 49.8439C170.208 51.9625 177.511 54.0812 183.198 56.1998C188.885 58.3184 193.736 61.6637 197.75 66.2355C201.876 70.8073 203.939 76.996 203.939 84.8015C203.939 91.4919 202.043 97.6248 198.252 103.2C194.572 108.664 188.997 113.013 181.526 116.247ZM158.109 21.744C168.925 21.744 179.741 24.8104 190.558 30.9433L198.921 10.3702C193.568 7.02497 187.324 4.4603 180.187 2.67618C173.051 0.892059 165.747 0 158.276 0C147.572 0 138.484 1.61686 131.013 4.85058L158.109 21.744ZM127.333 117.417C118.747 114.853 111.833 111.563 106.593 107.549L115.792 87.1431C120.81 90.8229 126.775 93.7778 133.689 96.008L127.333 117.417Z",
    fill: "#007ACC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.166a26c7.svg";
export { ForwardRef as ReactComponent };